<template>
  <div class="section_gap_x section_gap_y">
    <div class="img_wraper">
      <img :src="catelogue.image_link" alt="">
    </div>

    <div>
      <div class="title_header section_gap_y">
        <p class="shop_label sp_title_lg">{{catelogue.title}}</p>
        <p class="sp_title_md description">{{catelogue.description}}</p>
      </div>
    </div>
    <div v-if="catelogue.variants">

      <section class="variant_grid_container">
        <div class="grid_system grid_header">
          <!-- header row -->
          <div>{{$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.TITLE")}}</div>
          <div>{{$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.PRICE")}}</div>
          <div>{{$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.QUANTITY")}}</div>
          <div>{{$t("CATELOGUE_ITEM.VARIANT.TABLE_HEADER.TOTAL_PRICE")}}</div>
        </div>
        <template v-if="!isCatalogLoading">
          <div v-for="(variant, index) in catelogue.variants" :key="index" class="grid_system grid_data">
            <div class="word_break">{{ variant.display_title }}</div>
            <div class="align_right">{{ variant.price }}</div>
            <div>
              <div class="controll_btns">
                  <span class="controll_icon" @click="decreaseQuantity(index)"><fluent-icon icon="subtract" /></span>
                  {{ variant.orderQuantity }}
                  <span class="controll_icon" @click="increaseQuantity(index)"><fluent-icon icon="add" /></span>
                </div>
            </div>
            <div class="align_right">{{ (variant.price * variant.orderQuantity).toFixed(2) }}</div>
          </div>
        </template>
        <loader-round v-if="isCatalogLoading"  />
        <p v-if="!isCatalogLoading && !catelogue.variants.length" class="no_item">No product available</p>
      </section>


      <div>
        <div class="action_btns section_gap_y">
          <shop-button
            :disabled="isOrderButtonDisabled || isAddToCartDisabled || isNotInBusinessHours"
            @click="addToCartHandler">
            {{$t("CATELOGUE_ITEM.VARIANT.BTNS.ADD_TO_CART")}}
          </shop-button>
          <shop-button
            @click="orderNowhandler"
            :disabled="isOrderButtonDisabled || isAddToCartDisabled || isNotInBusinessHours"
          >
            <!-- {{$t("CATELOGUE_ITEM.VARIANT.BTNS.ORDER")}} -->
            Continue
          </shop-button>
        </div>
        <p v-if="isNotInBusinessHours" style="text-align:center;">{{$t("CATELOGUE_ITEM.VARIANT.BTNS.BUSINESS_HOUR_MSG")}}</p>
        <p v-if="isOrderExist" style="text-align:center;">{{$t("CATELOGUE_ITEM.VARIANT.BTNS.ORDER_EXIST")}}</p>
      </div>

    </div>

  </div>
</template>

<script>
import ShopButton from '../../../components/ShopButton.vue';
import CatelogueItemAPI from "../../../api/catelogueItemAPI";
import {StorageHelpers,SHOP_CONSTANT} from "./merchantHelper";
import alertMixin from 'shared/mixins/alertMixin';
import placeholderImage from "../../../../dashboard/assets/images/external/img_placeholder.jpg"
import LoaderRound from '../components/LoaderRound.vue';


export default {
  components: {
    ShopButton,
    LoaderRound,
  },
  mixins:[alertMixin],
  data() {
    // const merchant = StorageHelpers.getMerchantById(this.$route.params.accountId);
    return {
      // merchant,
      category_id: null,
      catelogue: {variants:[]},
      isAddToCartDisabled: false,
      isCatalogLoading: false,
    };
  },
  computed:{
    merchant(){
      return this.$store.getters["merchants/getCurrentMerchant"](this.$route.params.accountId);
    },
    currentCart(){
      return this.$store.getters["carts/getCurrentCart"](this.$route.params.accountId);
    },
    isOrderButtonDisabled(){
      return this.catelogue.variants?.every(variant=>variant.orderQuantity === 0)
    },
    isNotInBusinessHours() {
      return this.isOutsideBusinessHours();
    },
    isOrderExist(){
      return !!this.currentCart?.summary?.order_id;
    },
  },
  mounted() {
    this.$store.dispatch("carts/get",{ })
    this.fetchProductById();
    this.checkCurrentOrderStatus();
  },
  methods: {
    safePrice(str) {
      if (!str) return 0;

      const firstPart = str.split(" ")[0];
      if (!firstPart) return 0;

      const cleaned = firstPart.replace(/,/g, '');
      const value = parseFloat(cleaned);

      return isNaN(value) ? 0 : value;
    },
    async fetchProductById() {
      const category_id = this.$route.query.product_id;
      if (!category_id) {
        return
      }
      try {
        this.isCatalogLoading = true;
        const {data} = await CatelogueItemAPI.getCatelogueItemByCategoryId(category_id);
        // filter variant.price > 0
        this.catelogue = data || {variants:[]}

        // add the main catalogue as a variant
        const mainItemPrice = this.safePrice(data.price);
        if (mainItemPrice > 0) {
          this.catelogue.variants.unshift({
            id: data.id,
            title: data.title || "",
            price: mainItemPrice,
            available_inventory: data.available_inventory,
            display_title: data.display_title,
          })
        }

        this.catelogue.image_link = await this.getValidImageUrl(this.catelogue.image_link);
        // const existingCart = StorageHelpers.getCartById(this.$route.params.accountId);

        const newVariants = this.catelogue.variants.map(variant=>{
          const existingItem = this.currentCart.order_items.find(item => item.varient_id === variant.id);
          const orderQuantity = existingItem ? existingItem.orderQuantity : 0;

          return {
            ...variant,
            price: parseFloat(variant.price),
            orderQuantity,
          }
        }).filter(variantEl => variantEl.price > 0 && variantEl.available_inventory> 0);
        this.catelogue.variants = newVariants;

      } catch (error) {
        console.error('Error fetching product:', error);
        this.showAlert(this.$t("CATELOGUE_ITEM.API_ERR.CATELOGUE_FETCH"));
      }finally{
        this.isCatalogLoading = false;
      }
    },
    increaseQuantity(index) {
      // available_inventory
      if (this.catelogue.variants[index].available_inventory < (this.catelogue.variants[index].orderQuantity + 1)) {
        this.showAlert("Insufficient inventory!");
        return
      }
      this.catelogue.variants[index].orderQuantity++;
    },
    decreaseQuantity(index) {
      if (this.catelogue.variants[index].orderQuantity > 0) {
        this.catelogue.variants[index].orderQuantity--;
      }
    },
    async addToCartHandler() {
      // let existingCart = StorageHelpers.getCartById(this.$route.params.accountId);
      let existingCart = this.currentCart;
      existingCart.currency = this.catelogue.price?.split(" ")[1];

      this.catelogue.variants.forEach(variant => {
        if (variant.orderQuantity === 0) {
          let index = existingCart.order_items.findIndex(item => item.varient_id === variant.id);
          if (index !== -1) {
            existingCart.order_items.splice(index, 1);
          }
        }
      });

      this.catelogue.variants.forEach(variant => {
        if (variant.orderQuantity > 0) {
          let existingItem = existingCart.order_items.find(item => item.varient_id === variant.id);
          if (existingItem) {
            existingItem.orderQuantity = variant.orderQuantity;
          } else {
            existingCart.order_items.push({
              item_price: variant.price,
              orderQuantity: variant.orderQuantity,
              catalog_item_id: this.catelogue.id,
              catalog_title: this.catelogue.title,
              varient_id: variant.id,
              varient_title: variant.title,
              display_title: variant.display_title,
              image_link: this.catelogue.image_link,
            });
          }
        }
      });

      // Calculate cart totals
      const cartWithTotalSummary = this.calculateCartTotals(existingCart);
      // StorageHelpers.updateCartById(this.$route.params.accountId,cartWithTotalSummary);
      await this.$store.dispatch("carts/updateCartById",{
        accountId: this.$route.params.accountId,
        cart: cartWithTotalSummary
      })
      bus.$emit('cart_updated_event',cartWithTotalSummary);
      this.showAlert(this.$t("CATELOGUE_ITEM.CART.BTN.ADD"));
      // navigate to home
      this.$router.push(`/app/accounts/${this.$route.params.accountId}`);
    },
    calculateCartTotals(cart) {
      const updatedOrderItems = cart.order_items.map(item => {
        const total = parseFloat(item.item_price) * item.orderQuantity;
        return {
          ...item,
          total: parseFloat(total.toFixed(2))
        };
      });

      const sumTotal = updatedOrderItems.reduce((acc, item) => acc + parseFloat(item.total), 0);

      const sst = this.merchant.sst === 'true' ? parseFloat(sumTotal * 0.08) : 0;  // 8% of total
      const grantTotal = sumTotal + sst;

      return {
        ...cart,
        order_items: updatedOrderItems,
        summary: {
          sumTotal: parseFloat(sumTotal.toFixed(2)),
          sst: parseFloat(sst.toFixed(2)),
          grantTotal: parseFloat(grantTotal.toFixed(2)),
        }
      };
    },
    async orderNowhandler() {
      if (!this.isAddToCartDisabled) {
        await this.addToCartHandler();
      }
      this.$router.push(`/app/accounts/${this.$route.params.accountId}/order`)
    },
    checkCurrentOrderStatus(){
      const cart = StorageHelpers.getCartById(this.$route.params.accountId);

      // don't add new product if already has a pending/completed cart
      const {COMPLETED,PENDING} = SHOP_CONSTANT.ORDER_STATUS
      if ((cart?.summary?.order_status === PENDING)||(cart?.summary?.order_status === COMPLETED)) {
        this.isAddToCartDisabled = true;
      }
      // if the cart already has an active order disable all button
      if (cart?.summary?.order_id) {
        // console.log("Active order found and disabling btn");
        this.isAddToCartDisabled = true;
      }
    },
    isOutsideBusinessHours() {
      const merchant = StorageHelpers.getMerchantById(this.$route.params.accountId);

      const currentDay = new Date().getDay().toString();
      const currentTime = new Date().toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
      }); // get current time in "HH:mm" format

      console.log({currentDay,currentTime});

      const businessHour = merchant.business_hours?.find(
        (hour) => hour.day?.toString() === currentDay
      );

      if (businessHour) {
        const { open, close } = businessHour;
        const [openHour, openMinute] = open.split(":").map(Number);
        const [closeHour, closeMinute] = close.split(":").map(Number);
        const [currentHour, currentMinute] = currentTime.split(":").map(Number);

        const isOpen = currentHour > openHour || (currentHour === openHour && currentMinute >= openMinute);
        const isClosed = currentHour < closeHour || (currentHour === closeHour && currentMinute < closeMinute);
        console.log({isOpen,isClosed});
        return !isOpen || !isClosed;
      } else {
        return true; // disable button if no business hours for the current day
      }
    },

    async getValidImageUrl(url) {
      return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(url);
          img.onerror = () => resolve(placeholderImage);
          img.src = url;
      });
    },


  }
}
</script>

<style lang="scss" scoped>
  .img_wraper{
      max-width: 400px;
      width: 100%;
      margin: auto;
      padding: var(--p-sm);
      background-color: var(--bg-secondary);
      border-radius: var(--b-md);

      img{
        object-fit: cover;
        height: 350px;
        width: 100%;
      }
  }

  .title_header{
    .description{
      font-weight: 500;
      color: var(--txt-secondary-light);
    }
  }

  .action_btns{
    display: flex;
    justify-content: space-around;
    gap: 10px;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }



.variant_grid_container{
  max-width: 100%;
  border-radius: var(--b-md);
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  overflow-x: auto;
}
.grid_system{
  display: grid;
  grid-template-columns: 1fr 80px 100px 90px;
  gap: 1px;
  // padding: 0.8rem 1rem 1rem;
  > div{
    border-right: 1px solid #c4bebe;
    padding: 1rem 0.8rem;
    @media(max-width: 480px){
      padding: 0.8rem 0.6rem;
    }
  }
  @media(max-width: 480px){
    grid-template-columns: 1fr 60px 70px 70px;
  }
}
.grid_header{
  min-height: 60px;
  font-weight: 600;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  font-size: 1.4rem;
  background-color: var(--primary-color);
  color: #fff;
  @media(max-width: 480px){
    font-size: 1.2rem;
  }

  div{
    display: flex;
    align-items: center;
  }
}
.grid_data{
  font-size: 14px;
  color: #3c4858;
}
.grid_data:nth-of-type(odd) {
  background-color: var(--bg-secondary);
}

.align_right{
  text-align: right;
}

.controll_btns{
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  max-width: 180px;
  margin: auto;
}
.controll_icon{
  max-width: 20px;
  max-height: 20px;
  border: 1px solid;
  display: flex;
  border-radius: 50%;
  background-color:  var(--primary-color);
  cursor: pointer;
  svg{
    color: #fff;
  }
}
.no_item{
  text-align: center;
  margin: 40px auto 40px auto;
}
</style>